<template>
  <div class="portlet light">
    <i class="fa fa-arrows-alt arrow-move" aria-hidden="true"></i>
    <div class="module-name">GENERAL FORMS</div>
    <div class="portlet-title tabbable-line">
      <div class="caption">
        <i class="icon-globe font-dark hide"></i>
        <span class="caption-subject font-dark bold uppercase">GENERAL FORMS</span>
      </div>

    </div>
    <vue-spinner v-if="getLoading"></vue-spinner>
    <div class="portlet-body" v-else>
      <!--BEGIN TABS-->
      <div class="tab-content">
        <div class="tab-pane active" id="tab_1_1">
          <div class="scroll-section" style="height: 350px; overflow: hidden;" v-bar>
            <ul class="feeds" v-if="workspace.general_forms && workspace.general_forms.length">
              <li v-for="record in workspace.general_forms">
                <router-link :to="{ name: 'General Forms Edit', params: { id: $route.params.id, dataid: record.id } }" tag="a">
                  <div class="col1">
                    <div class="cont">
                      <div class="cont-col2">
                        <div class="desc">{{ record.form_name }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col2">
                    <div class="date">{{ record.created_date.date | formatDateModal }}</div>
                  </div>
                </router-link>
              </li>
            </ul>
            <div v-else>
              <p>No records available.</p>
            </div>
          </div>
        </div>
      </div>
      <!--END TABS-->
      &nbsp
    </div>
    <div class="btn-arrow-link pull-right">
      <router-link :to="{ name: 'General Forms', params: { id: $route.params.id }}" tag="a" class="text-warning">VIEW ALL | NEW</router-link>
      <i class="icon-arrow-right"></i>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Spinner from '@/components/Spinner';
  export default {

    components: {
      'vue-spinner': Spinner
    },
    computed: {
      ...mapGetters({
        workspace: 'getWorkspace',
        getLoading: 'getWorkspaceLoading'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// GeneralForms.vue?5ff68f83